import Vue from "vue";

import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import axios from "axios";
import Vuelidate from "vuelidate";

import VueAnalytics from "vue-analytics";

import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUser,
  faFilePowerpoint,
  faFilePdf
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faUser, faFilePowerpoint, faFilePdf);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;
Vue.use(Vuelidate);
Vue.use(BootstrapVue);
Vue.use(VueAnalytics, {
  id: "UA-48005409-2",
  router
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.public)) {
    next();
  } else if (to.matched.some(record => record.meta.admin)) {
    if (!store.getters.user ? false : store.getters.user.adminpermission) {
      next();
      return;
    } else {
      next("/");
    }
  } else {
    if (store.getters.isAuthenticated) {
      next();
      return;
    }
    next("/signin");
  }
});

axios.defaults.baseURL = "https://vue-update-76d11.firebaseio.com";
axios.defaults.headers.get["Accepts"] = "application/json";

new Vue({
  render: h => h(App),
  router,
  store
}).$mount("#app");
